
import { axiosPost, axiosGet } from "../../react_axios/Axios"
import {
    headers,
    getHotelBookinFormDetailsUrl, getHotelBookinFormListUrl, insertUpdateHotelBookinFormUrl,
    GET_HOTEL_BOOKING_FORM_DETAILS, GET_HOTEL_BOOKING_FORM_LIST, INSERT_UPDATE_HOTEL_BOOKING_FORM
} from "../../utils/constants"

export const getHotelBookinFormDetails_action = (HotelBookingFormHdrID) => async (dispatch) => {
    try {

        const mapdata = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ExhRegistrationID: sessionStorage.getItem("ExhRegistrationIDSS"),
            ExhVisitorID: JSON.parse(sessionStorage.getItem('VisitorDataSS')) != null ? JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID : null,
            HotelBookingFormHdrID:HotelBookingFormHdrID
        }

        const res = await axiosGet(getHotelBookinFormDetailsUrl, mapdata, headers);
        dispatch({
            type: GET_HOTEL_BOOKING_FORM_DETAILS,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};


export const getHotelBookinFormList_action = (ApplicationNo, CompanyName) => async (dispatch) => {
    try {

        const mapdata = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ApplicationNo: ApplicationNo != '' ? ApplicationNo : null,
            CompanyName: CompanyName != '' ? CompanyName : null,
        }

        const res = await axiosGet(getHotelBookinFormListUrl, mapdata, headers);
        dispatch({
            type: GET_HOTEL_BOOKING_FORM_LIST,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const insertUpdateHotelBookinForm_action = (ActionID, HotelBookingFormHdrID, FirstName, LastName, EmailID, CountryID, MobileNo, NumberofRooms, NumberofRoomsList) => async (dispatch) => {
    try {

        const mapdata = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ExhRegistrationID: sessionStorage.getItem("ExhRegistrationIDSS"),
            ActionID: ActionID,
            HotelBookingFormHdrID: HotelBookingFormHdrID,
            ExhVisitorID: JSON.parse(sessionStorage.getItem('VisitorDataSS')) != null ? JSON.parse(sessionStorage.getItem('VisitorDataSS')).ExhVisitorID : null,
            FirstName: FirstName,
            LastName: LastName,
            EmailID: EmailID,
            CountryID: CountryID,
            MobileNo: MobileNo,
            NumberofRooms: NumberofRooms,
            NumberofRoomsList: NumberofRoomsList,
        }

        const res = await axiosPost(insertUpdateHotelBookinFormUrl, mapdata, headers);
        dispatch({
            type: INSERT_UPDATE_HOTEL_BOOKING_FORM,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};
